import { memo } from "react";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectInspectionData } from "../../store/selectors/inspectionSelectors";
import { formatInspectionDate } from "../../utils/inspectionHelper";
import { Card } from "primereact/card";
import { InspectionStatusTag } from "./InspectionStatusTag";
import { selectDefects } from "../../store/selectors/defectSelectors";
import { selectPositiveItems } from "../../store/selectors/positiveItemSelectors";

export const InspectionInfo = memo(() => {
  const inspection = useAppSelector(selectInspectionData);
  const defects = useAppSelector(selectDefects);
  const positives = useAppSelector(selectPositiveItems);

  if (!inspection) {
    return null;
  }

  return (
    <Card className="p-3 mb-3" title="Inspection Defects Editor">
      <div className="flex">
        <div className="flex flex-column gap-2 mr-4 w-6">
          <div className="flex flex-column">
            <div className="font-bold">Inspection Number:</div>
            <div>{inspection.inspectionNumber}</div>
          </div>

          <div className="flex flex-column">
            <div className="font-bold">Ship Name:</div>
            <div>{inspection.vesselName}</div>
          </div>

          <div className="flex flex-column">
            <div className="font-bold">Inspection Type:</div>
            <div>{inspection.inspectionType}</div>
          </div>
        </div>

        <div className="flex flex-column gap-2 w-6">
         <div className="flex flex-column">
            <div className="font-bold">Status:</div>
            <div>
                <InspectionStatusTag status={inspection.status} />
            </div>
          </div>

          <div className="flex flex-column">
            <div className="font-bold">Date:</div>
            <div>{formatInspectionDate(inspection)}</div>
          </div>

          <div className="flex flex-column">
            <div className="font-bold">Location:</div>
            <div>{inspection.port}, {inspection.country}</div>
          </div>
        </div>

        <div className="flex flex-column gap-2 w-6">
         <div className="flex flex-column">
            <div className="font-bold">Total Defects:</div>
            <div>
                {defects.length}
            </div>
          </div>

          <div className="flex flex-column">
            <div className="font-bold">Total Positive Items:</div>
            <div>
                {positives.length}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
});
